import { Box, TextField, IconButton, Typography, Chip, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useHatm } from '../../context/HatmContext';
import { StickyFooter } from '../../styles/hatm.styles';
import { submitJuzSelection } from '../../utils/hatmOperations';
import { useState, useEffect } from 'react';
import confetti from 'canvas-confetti';

export default function HatmFooter({ hatmId }) {
  const { 
    chosenJuzs, 
    setChosenJuzs,
    name, 
    setName,
    setAlert,
    setAlertMessage,
    state 
  } = useHatm();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (chosenJuzs.length === 0) {
      setAlertMessage("Hiç cüz seçmediniz!");
      setAlert(true);
      return;
    }

    if (!name.trim()) {
      setAlertMessage("İsminizi Girmelisiniz!");
      setAlert(true);
      return;
    }

    await submitJuzSelection(hatmId, chosenJuzs, name, state);
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 }
    });
    setChosenJuzs([]);
  };

  return (
    <StickyFooter>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          gap: 1,
          alignItems: 'flex-start' 
        }}>
          <Typography variant="h6">
            {chosenJuzs.length > 0 
              ? `${chosenJuzs.length} Cüz Seçildi`
              : "Henüz cüz seçmedin"}
          </Typography>
          <Box sx={{ 
            display: 'flex', 
            gap: 1,
            flexWrap: 'wrap' 
          }}>
            {chosenJuzs.map((juz) => (
              <Chip 
                key={juz} 
                label={`${juz}`}
                color="primary"
                variant="outlined"
              />
            ))}
          </Box>
        </Box>

        <Box 
          component="form" 
          onSubmit={handleSubmit}
          sx={{ display: 'flex', gap: 2 }}
        >
          <TextField
            margin="dense"
            autoComplete="given-name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            name="firstName"
            required
            fullWidth
            id="firstName"
            label="İsim, Soyisim"
            variant="outlined"
            size="small"
            className="hatm-footer-name"
          />
          <IconButton
            type="submit"
            color="primary"
            disabled={!chosenJuzs.length || !name}
            sx={{ 
              backgroundColor: '#EDAFB8',
              width: '48px',
              height: '48px',
              transition: 'all 0.2s ease-in-out',
              '&:hover': {
                backgroundColor: '#e39aa5',
                transform: 'scale(1.05)',
                boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
              },
              '&:active': {
                transform: 'scale(0.95)',
              },
              '&:disabled': {
                backgroundColor: '#f0f0f0',
                transform: 'none',
                boxShadow: 'none'
              }
            }}
            className="hatm-footer-submit"
          >
            <ArrowForwardIcon sx={{ fontSize: '1.5rem' }} />
          </IconButton>
        </Box>
      </Box>
    </StickyFooter>
  );
} 